import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function BookCover({
  size = "md",
  className = "",
  testId = "book-cover",
  interactive = false,
}) {
  const dims =
    size === "lg"
      ? { w: "min(560px, 92vw)", h: "min(560px, 92vw)" }
      : size === "sm"
      ? { w: "260px", h: "260px" }
      : { w: "min(440px, 90vw)", h: "min(440px, 90vw)" };

  const pointerX = useMotionValue(0.5);
  const pointerY = useMotionValue(0.5);
  const smoothX = useSpring(pointerX, { stiffness: 120, damping: 22 });
  const smoothY = useSpring(pointerY, { stiffness: 120, damping: 22 });
  const rotateY = useTransform(smoothX, [0, 1], [-4, 4]);
  const rotateX = useTransform(smoothY, [0, 1], [4, -4]);

  const onPointerMove = (event) => {
    if (!interactive) return;
    const bounds = event.currentTarget.getBoundingClientRect();
    pointerX.set((event.clientX - bounds.left) / bounds.width);
    pointerY.set((event.clientY - bounds.top) / bounds.height);
  };

  const onPointerLeave = () => {
    pointerX.set(0.5);
    pointerY.set(0.5);
  };

  return (
    <motion.div
      data-testid={testId}
      className={`book-cover relative overflow-hidden ${className}`}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
      style={{
        width: dims.w,
        height: dims.h,
        rotateX: interactive ? rotateX : 0,
        rotateY: interactive ? rotateY : 0,
        transformPerspective: 1100,
        backgroundColor: "#F2EBE3",
        boxShadow:
          "0 1px 0 0 rgba(28,28,26,0.06), 0 18px 40px -28px rgba(28,28,26,0.25)",
        border: "1px solid rgba(28,28,26,0.06)",
      }}
    >
      <div
        className="absolute"
        style={{
          left: "30%",
          top: "22%",
          transform: "rotate(180deg)",
          writingMode: "vertical-rl",
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "0.6rem",
          letterSpacing: "0.34em",
          color: "rgba(28,28,26,0.70)",
        }}
      >
        NOTHING IN THE WAY
      </div>

      <div
        className="absolute"
        style={{
          right: "8%",
          top: "26%",
          textAlign: "right",
          maxWidth: "55%",
        }}
      >
        <h3
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
            color: "#1C1C1A",
            fontSize: "clamp(1.55rem, 4.4vw, 2.5rem)",
            lineHeight: 1.05,
            letterSpacing: 0,
            margin: 0,
          }}
        >
          Nothing in the Way
        </h3>
        <div
          style={{
            height: "1px",
            background: "rgba(28,28,26,0.55)",
            width: "30%",
            marginTop: "12px",
            marginLeft: "auto",
          }}
        />
        <p
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontStyle: "italic",
            color: "rgba(28,28,26,0.65)",
            fontSize: "clamp(0.62rem, 1.1vw, 0.78rem)",
            letterSpacing: "0.04em",
            marginTop: "10px",
            marginBottom: 0,
          }}
        >
          A Memoir
        </p>
      </div>

      <div
        className="absolute"
        style={{
          left: "10%",
          top: "62%",
          maxWidth: "38%",
          fontFamily: "'Cormorant Garamond', serif",
          fontStyle: "italic",
          color: "rgba(28,28,26,0.65)",
          fontSize: "clamp(0.58rem, 1vw, 0.74rem)",
          lineHeight: 1.6,
          textAlign: "center",
        }}
      >
        “The stars have not moved. They were never lost.
        <br />
        I had only been looking at the clouds —
        <br />
        and missing the sky that held them.”
      </div>

      <div
        className="absolute"
        style={{
          left: "50%",
          top: "62%",
          transform: "rotate(180deg)",
          writingMode: "vertical-rl",
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "0.58rem",
          letterSpacing: "0.34em",
          color: "rgba(28,28,26,0.70)",
        }}
      >
        RAHUL BHASKAR
      </div>

      <div
        className="absolute"
        style={{
          right: "8%",
          bottom: "8%",
          fontFamily: "'Cormorant Garamond', serif",
          color: "rgba(28,28,26,0.85)",
          fontSize: "clamp(0.78rem, 1.4vw, 1rem)",
          letterSpacing: "0.02em",
        }}
      >
        Rahul Bhaskar
      </div>
      <div className="book-cover-sheen" aria-hidden="true" />
    </motion.div>
  );
}
